module.exports = __webpack_public_path__ + "4dec2fbcb807b167c19e3a55e84d700c.jpg";